import api from '../../api';

export default class PaymentAvailabilityService implements PaymentAvailabilityService {
    async getCashPaymentAvailability(cartID: string): Promise<PaymentAvailabilityResponse> {
        const response = await api.bff.getCashPaymentAvailability(cartID);
        return response.data;
    }
}
